<template>
  <!-- START Bootstrap-Cookie-Alert -->
  <div class="alert text-center cookiealert fixed-bottom" role="alert">
    <div class="cookie-choices-inner">
    <span class="cookie-choice-text">
      Deze site gebruikt cookies van Google om services te leveren en verkeer te analyseren.
        Je IP-adres en user-agent worden met Google gedeeld, samen met prestatie- en beveiligingsstatistieken
        om servicekwaliteit te garanderen, gebruiksstatistieken te genereren, misbruik te detecteren en
        maatregelen te treffen.
    </span>
      <span class="cookie-choices-buttons">
    <a href="https://policies.google.com/technologies/cookies?hl=nl" target="_blank">Meer informatie</a>
    <button type="button" class="btn btn-primary btn-sm acceptcookies" aria-label="Close">
      Ok
    </button>
    </span>
    </div>
  </div>
  <!-- END Bootstrap-Cookie-Alert -->
</template>

<script>

export default {
  name: 'Cookie-alert',
  methods: {
    cookieAlert() {
     /*
     * Modification of Bootstrap Cookie Alert by Wruczek
     * https://github.com/Wruczek/Bootstrap-Cookie-Alert
     * Released under MIT license
     */

      let cookieAlert = document.querySelector(".cookiealert");
      let acceptCookies = document.querySelector(".acceptcookies");

      if (!cookieAlert) {
        return
      }

      cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

      // Show the alert if we cant find the "acceptCookies" cookie
      if (!getCookie("acceptCookies")) {
        cookieAlert.classList.add("show")
      }

      // When clicking on the agree button, create a 1 year
      // cookie to remember user's choice and close the banner
      acceptCookies.addEventListener("click", () => {
        setCookie("acceptCookies", true, 365)
        cookieAlert.classList.remove("show")
      });

      // Cookie functions from w3schools
      function setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
      }

      function getCookie(cname) {
        let name = cname + "="
        let decodedCookie = decodeURIComponent(document.cookie)
        let ca = decodedCookie.split(';')
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i]
          while (c.charAt(0) === ' ') {
            c = c.substring(1)
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
          }
        }
        return ""
      }
    }
  },
  mounted() {
    this.cookieAlert()
  }
}
</script>

<style lang="scss">
@import '../scss/components/cookie-alert';

</style>
